// extracted by mini-css-extract-plugin
export default {"flexColumn":"flexColumn---gWoIb"};